var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kn-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"loading":_vm.loading,"tableTitle":"Productos","newButtonLabel":"Agregar producto"}})}
var staticRenderFns = []

export { render, staticRenderFns }